<template>
  <el-card id="UserOtherTab">
    <el-tabs v-model="activeName">
      <template v-for="item in comps">
        <el-tab-pane :key="item.name" :label="$t(item.label)" :name="item.name">
          <component
              :backTop="false"
              :auto="false"
              :page-sizes="[5, 10]"
              :tabCurrent="item.name"
              :current="activeName"
              :is="item.name" />
        </el-tab-pane>
      </template>
    </el-tabs>
  </el-card>
</template>

<script>
import CookRecord from "@/components/user/CookRecord";
import DietRecord from "@/components/user/DietRecord";
import DeviceMange from "@/components/user/DeviceMange";
export default {
  name: "UserOtherTab",
  components: {DeviceMange, DietRecord, CookRecord},
  data() {
    return {
      activeName: null,
      comps: [
        {name: "CookRecord", label: "煮饭记录"},
        {name: "DietRecord", label: "饮食记录"},
        {name: "DeviceMange", label: "硬件管理"},
      ]
    }
  },
  mounted() {
    // 监听组件是否出现在视口
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        console.log('组件出现在视口 UserOtherTab');
        this.activeName = "CookRecord";
        this.observer.unobserve(document.getElementById("UserOtherTab"));
      }
    })

    this.observer.observe(document.getElementById("UserOtherTab"));
    this.$once('hook:beforeDestroy', () => {
      this.observer.disconnect();
    })
  },
}
</script>

<style scoped>

</style>
